import LeadRepository from "@adapters/salesFeatures/Lead/repositories/Lead";
export default (function (http) {
    return {
        leads: new LeadRepository(http),
    };
});
